<template>
  <div class="main">
    <report-top>
      <ly-search
        slot="search"
        v-model="searchItem.keyword"
        @search="search"
      ></ly-search
    ></report-top>
    <div id="formTable">
      <div id="text">运输事件列表</div>
      <div id="ddas">
        <!-- <Button @click="reOpenWin" type="primary" size="small" icon="md-cloud-download">导出</Button>-->
        <Button @click="openAdd" type="primary" size="small" icon="md-add"
          >新增</Button
        >
      </div>
    </div>

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
    >
      <template slot-scope="{ row, index }" slot="icon">
        <img :src="'static/' + row.icon + '/4/3.gif'" style="width: 30px" />
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="opemUpdate(row, index)">编辑</Button>
        <Button size="small" @click="del(row, 1)">删除</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <form-model
      :title="isAdd ? '新增运输事件' : '编辑运输事件'"
      ref="formModel"
      :labelWidth="100"
      width="700"
    >
      <addressList
        slot="shippingAddressList"
        v-model="item.shippingAddressList"
      >
      </addressList>
      <addressList slot="pickupAddressList" v-model="item.pickupAddressList">
      </addressList>
      <Button slot="btn" type="primary" @click="addUpdate">提交表单</Button>
    </form-model>
  </div>
</template>
<script>
import addressList from "./addressList.vue";
export default {
  components: { addressList },
  data() {
    return {
      isAdd: false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "操作",
          slot: "action",
          width: 130,
          align: "center",
          fixed: "right",
        },
      ],
      tableData: [],
      item: {
        ono: "", //订单号
        tno: "", ////任务单号
        groupId: "",
        groupName: "",
        carNo: "",
        status: "0", //任务状态(0-待审,1-通过,2-驳回)
        driverId: "",
        driver: "",
        dispatcher: "",
        dispatcherId: "",
        step: "提货", //环节(提货，送货，报关，仓储，其它)
        content: "",
        startTime: new Date().getTime(),
        processTime: new Date().getTime() + 86400000,
        processResult: "",
        remark: "",
        imgPath: "",
        imgPath2: [],
      },

      searchItem: {
        keyword: "",
        pageNumber: 1,
        pageSize: 50,
      },
      total: 0,
      categorys: [],
      forms: [
        {
          title: "订单号",
          key: "ono",
          type: "Select",
          selectItems: [],
          required: true,
        },
        {
          title: "任务单号",
          key: "tno",
          type: "Select",
          selectItems: [],
          required: true,
        },
        {
          title: "环节",
          key: "step",
          type: "Select",
          selectItems: ["提货", "送货", "报关", "仓储", "其它"],
          required: true,
        },
        {
          title: "单位名称",
          key: "groupId",
          key1: "groupName",
          multiple: true,
          type: "selectGroup",
          required: true,
        },
        {
          title: "事件说明",
          key: "content",
          type: "Input",
          required: true,
        },
        {
          title: "任务状态",
          key: "status",
          key2: "status2",
          type: "Select1",
          st: "taskStatus",
          required: true,
        },
        {
          title: "开始时间",
          key: "startTime",
          key: "startTime2",
          formate:'datetime',
          type: "lyyymmdd",
          required: true,
        },
        {
          title: "事件处理时间",
          key: "processTime",
          key: "processTime2",
          formate:'datetime',
          type: "lyyymmdd",
        },
        {
          title: "处理结果",
          key: "processResult",
          type: "Input",
        },
        {
          title: "物流车辆",
          key: "carNo",
          type: "Input",
        },
        {
          title: "驾驶员",
          key: "driver",
          type: "Input",
        },
        {
          title: "调度员",
          key4: "dispatcherId",
          key1: "dispatcher",
          type: "selectUser",
        },
        {
          title: "附件名称",
          key: "imgPath2",
          type: "lyPhoto",
        },

        {
          title: "备注信息",
          key: "remark",
          type: "Input",
          type1: "textarea",
        },
      ],
    };
  },
  methods: {
    getList() {
      console.log(this.searchItem);
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-ctc/event/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        for (let i = 0; i < data.length; i++) {
          data[i].status=String(data[i].status)
          data[i].status2=this.$t('taskStatus.'+data[i].status)
          data[i].processTime2=this.utils.time(data[i].processTime,'yymmddhhmm');
          data[i].startTime2=this.utils.time(data[i].startTime,'yymmddhhmm')
        }
        console.log(data);
        this.tableData = data;
      });
    },
    addUpdate(name) {
      var a = this.$refs.formModel.getItem();
      if (!a) {
        return;
      }
      a.imgPath = JSON.stringify(a.imgPath2);
      this.item = a;
      console.log(this.item);

      if (this.isAdd) {
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-tms-server-ctc/event/add",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      } else {
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-tms-server-ctc/event/update",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      }
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          this.axios({
            method: "post",
            url: this.axios.ipPort + "/cloud-tms-server-ctc/event/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      this.isAdd = false;
      this.item.imgPath = JSON.parse(this.item.imgPath);
      this.item = JSON.parse(JSON.stringify(row));
      this.$refs.formModel.reach(this.forms, this.item);
    },
    openAdd() {
      this.isAdd = true;
      this.item.imgPath = [];
      this.$refs.formModel.reach(this.forms, this.item);
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    search() {
      this.getList();
    },
    //carTypeCategory
    getOrdersList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-omc/orders/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;

        for (let i = 0; i < this.forms.length; i++) {
          if (this.forms[i].key == "ono") {
            this.forms[i].selectItems = [];
            for (let j = 0; j < data.length; j++) {
              this.forms[i].selectItems.push(data[j].no);
            }
          }
        }
      });
    },
    getTaskList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-ctc/transport/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;

        for (let i = 0; i < this.forms.length; i++) {
          if (this.forms[i].key == "tno") {
            this.forms[i].selectItems = [];
            for (let j = 0; j < data.length; j++) {
              this.forms[i].selectItems.push(data[j].no);
            }
          }
        }
      });
    },
    cols() {
      var b = JSON.parse(JSON.stringify(this.forms));
      //b.splice(2, 4);
      for (let i = 0; i < b.length; i++) {
        if (!b[i].minWidth && !b[i].maxWidth) {
          b[i].minWidth = 200;
          b[i].maxWidth = 300;
        }
        if (b[i].key1) {
          b[i].key = b[i].key1;
        }
        if (b[i].key2) {
          b[i].key = b[i].key2;
        }
      }
      this.columns.splice(1, 0, ...b);
      //a.splice.apply(a,[i,0].concat(b));//es5写法
    },
  },
  mounted() {
    this.cols();
    this.getList();
    this.getOrdersList();
    this.getTaskList();
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/wuliu/yunshushijian.vue